// Login.js
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom"
import { supabase } from '../supabase';
import Arrow from "../assets/back arrow.png";
import "../styles/Auth.css"

export default function Login() {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [newPassword, setNewPassword] = useState('');

  const [open, setOpen] = useState(false)

  const nav = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setMessage({ type: 'error', text: error.message });
    } else {
      setMessage({ type: 'success', text: 'Logged in successfully!' });
        nav("/documents", { replace: true })
        window.location.reload();
    }
    setLoading(false);
  };

  const handleSignup = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage({ type: '', text: '' });

  if (password !== confirmPassword) {
    setMessage({ type: 'error', text: 'Passwords do not match' });
    setLoading(false);
    return;
  }

  if (password.length < 6) {
    setMessage({ type: 'error', text: 'Password must be at least 6 characters' });
    setLoading(false);
    return;
  }

  if (!role) {
    setMessage({ type: 'error', text: 'Please select a role' });
    setLoading(false);
    return;
  }

  const { data, error } = await supabase.auth.signUp({
    email,
    password,
  });

  console.log(data);

  if (error) {
    setMessage({ type: 'error', text: error.message });
    setLoading(false);
    return;
  }

  // Insert role into profiles table
  const { error: insertError } = await supabase
    .from('profiles')
    .insert({
      id: data.user.id,
      role: role
    });

  if (insertError) {
    console.error('Profile insert error:', insertError);
    setMessage({ 
      type: 'error', 
      text: 'Account created but failed to save role. Please contact support.' 
    });
  } else {
    setMessage({ 
      type: 'success', 
      text: 'Account created successfully! Please check your email to verify your account.'
    });
  }
  
  setLoading(false);
  window.location.reload();
};

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    const { error } = await supabase.auth.resetPasswordForEmail(email);

    if (error) {
      setMessage({ type: 'error', text: error.message });
    } else {
      setMessage({ 
        type: 'success', 
        text: 'Password reset email sent! Check your inbox.' 
      });
    }
    setLoading(false);
  };

  const resetForm = () => {
    setEmail('');
    setPassword('');
    setConfirmPassword('');
    setMessage({ type: '', text: '' });
  };

  const switchMode = (newMode) => {
    setMode(newMode);
    resetForm();
  };

  const handleUpdatePassword = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage({ type: '', text: '' });

  if (newPassword.length < 6) {
    setMessage({ type: 'error', text: 'Password must be at least 6 characters' });
    setLoading(false);
    return;
  }

  if (newPassword !== confirmPassword) {
    setMessage({ type: 'error', text: 'Passwords do not match' });
    setLoading(false);
    return;
  }

  const { error } = await supabase.auth.updateUser({
    password: newPassword
  });

  if (error) {
    setMessage({ type: 'error', text: error.message });
  } else {
    setMessage({ 
      type: 'success', 
      text: 'Password updated successfully!' 
    });
    setTimeout(() => {
      switchMode('login');
    }, 1000);
  }
  setLoading(false);
};

  useEffect(() => {
  // Check if this is a password reset callback
  const queryParams = new URLSearchParams(window.location.search);
  const type = queryParams.get('type');
  const tokenHash = queryParams.get('token_hash');
  
  if (type === 'recovery' && tokenHash) {
    setMode('update-password');
    
    // Verify the recovery token to establish a session
    supabase.auth.verifyOtp({
      token_hash: tokenHash,
      type: 'recovery'
    }).then(({ error }) => {
      if (error) {
        console.error('Token verification error:', error);
        setMessage({ 
          type: 'error', 
          text: 'Invalid or expired reset link. Please request a new one.' 
        });
        setMode('reset');
      }
    });
  }
}, []);


  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // background: 'linear-gradient(135deg, #667eea 0%, #003171 100%)',
      background: '#e8ecf1',
      padding: "0 40px"
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '420px',
        padding: '40px',
        position: "relative"
      }}>
        <div className="backHome" onClick={() => {
          nav("/");
          window.location.reload();
        }}>
          <img className="homeText" src={Arrow} alt="back arrow" />
        </div>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ 
            margin: '0 0 8px 0', 
            fontSize: '28px', 
            color: '#1a202c',
            fontWeight: '700'
          }}>
            {mode === 'login' && 'Welcome Back'}
            {mode === 'signup' && 'Create Account'}
            {mode === 'reset' && 'Reset Password'}
            {mode === 'update-password' && 'Set New Password'}
          </h1>
          <p style={{ margin: 0, color: '#718096', fontSize: '14px' }}>
            {mode === 'login' && 'Sign in to continue to your account'}
            {mode === 'signup' && 'Sign up to get started'}
            {mode === 'reset' && 'Enter your email to reset password'}
            {mode === 'update-password' && 'Enter your new password'}
          </p>
        </div>

        {/* Message Alert */}
        {message.text && (
          <div style={{
            padding: '12px 16px',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            backgroundColor: message.type === 'error' ? '#fee' : '#efe',
            color: message.type === 'error' ? '#c33' : '#383',
            border: `1px solid ${message.type === 'error' ? '#fcc' : '#cfc'}`
          }}>
            {message.text}
          </div>
        )}

        {/* Login Form */}
        {mode === 'login' && (
          <div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '6px', 
                fontSize: '14px',
                fontWeight: '500',
                color: '#2d3748'
              }}>
                Email
              </label>
              <input
                onFocus={(e) => (e.target.style.border = '1px solid #003171')}
                onBlur={(e) => (e.target.style.border = '1px solid #e2e8f0')}
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '6px', 
                fontSize: '14px',
                fontWeight: '500',
                color: '#2d3748'
              }}>
                Password
              </label>
              <input
                onFocus={(e) => (e.target.style.border = '1px solid #003171')}
                onBlur={(e) => (e.target.style.border = '1px solid #e2e8f0')}
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <button
              type="button"
              onClick={() => switchMode('reset')}
              style={{
                background: 'none',
                border: 'none',
                color: '#003171',
                fontSize: '13px',
                cursor: 'pointer',
                padding: '0',
                marginBottom: '20px',
                textDecoration: 'underline'
              }}
            >
              Forgot password?
            </button>

            <button
              type="button"
              onClick={handleLogin}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                background: loading ? '#a0aec0' : '#003171',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                boxSizing: 'border-box'
              }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </div>
        )}

        {/* Signup Form */}
        {mode === 'signup' && (
          <div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '6px', 
                fontSize: '14px',
                fontWeight: '500',
                color: '#2d3748'
              }}>
                Email
              </label>
              <input
                onFocus={(e) => (e.target.style.border = '1px solid #003171')}
                onBlur={(e) => (e.target.style.border = '1px solid #e2e8f0')}
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '6px', 
                fontSize: '14px',
                fontWeight: '500',
                color: '#2d3748'
              }}>
                Password
              </label>
              <input
                onFocus={(e) => (e.target.style.border = '1px solid #003171')}
                onBlur={(e) => (e.target.style.border = '1px solid #e2e8f0')}
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '6px', 
                fontSize: '14px',
                fontWeight: '500',
                color: '#2d3748'
              }}>
                Confirm Password
              </label>
              <input
                onFocus={(e) => (e.target.style.border = '1px solid #003171')}
                onBlur={(e) => (e.target.style.border = '1px solid #e2e8f0')}
                type="password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '20px', position: 'relative' }}>
  <label
    style={{
      display: 'block',
      marginBottom: '6px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#2d3748'
    }}
  >
    Role
  </label>

  <div
    onClick={() => setOpen(!open)}
    style={{
      padding: '12px',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      background: '#fff',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}
  >
    <span style={{ color: role ? '#000' : '#a0aec0' }}>
      {role || 'Select your role'}
    </span>
    <span style={{ fontSize: '12px' }}>▼</span>
  </div>

  {open && (
    <div
      style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        marginTop: '4px',
        zIndex: 10,
        boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
      }}
    >
      {[
        'General User',
        'Physician',
        'Nurse',
        'Physical Therapist',
        'Occupational Therapist',
        'Physician Assistant',
        'Medical Student',
        'Researcher'
      ].map((item) => (
        <div
          key={item}
          onClick={() => {
            setRole(item);
            setOpen(false);
          }}
          style={{
            padding: '10px 12px',
            cursor: 'pointer',
            transition: 'background 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.background = '#f1f5f9'}
          onMouseLeave={(e) => e.target.style.background = 'transparent'}
        >
          {item}
        </div>
      ))}
    </div>
  )}
</div>




            <button
              type="button"
              onClick={handleSignup}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                background: loading ? '#a0aec0' : '#003171',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                boxSizing: 'border-box'
              }}
            >
              {loading ? 'Creating account...' : 'Create Account'}
            </button>
          </div>
        )}

        {/* Reset Form */}
        {mode === 'reset' && (
          <div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '6px', 
                fontSize: '14px',
                fontWeight: '500',
                color: '#2d3748'
              }}>
                Email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <button
              type="button"
              onClick={handleReset}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                background: loading ? '#a0aec0' : '#003171',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                boxSizing: 'border-box',
                marginBottom: '12px'
              }}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <button
              type="button"
              onClick={() => switchMode('login')}
              style={{
                width: '100%',
                padding: '12px',
                background: 'white',
                color: '#003171',
                border: '1px solid #003171',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                boxSizing: 'border-box'
              }}
            >
              Back to Login
            </button>
          </div>
        )}

        {/* Update Password Form */}
{mode === 'update-password' && (
  <div>
    <div style={{ marginBottom: '20px' }}>
      <label style={{ 
        display: 'block', 
        marginBottom: '6px', 
        fontSize: '14px',
        fontWeight: '500',
        color: '#2d3748'
      }}>
        New Password
      </label>
      <input
        onFocus={(e) => (e.target.style.border = '1px solid #003171')}
        onBlur={(e) => (e.target.style.border = '1px solid #e2e8f0')}
        type="password"
        required
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        placeholder="••••••••"
        style={{
          width: '100%',
          padding: '12px',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          fontSize: '14px',
          outline: 'none',
          boxSizing: 'border-box'
        }}
      />
    </div>

    <div style={{ marginBottom: '20px' }}>
      <label style={{ 
        display: 'block', 
        marginBottom: '6px', 
        fontSize: '14px',
        fontWeight: '500',
        color: '#2d3748'
      }}>
        Confirm New Password
      </label>
      <input
        onFocus={(e) => (e.target.style.border = '1px solid #003171')}
        onBlur={(e) => (e.target.style.border = '1px solid #e2e8f0')}
        type="password"
        required
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        placeholder="••••••••"
        style={{
          width: '100%',
          padding: '12px',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          fontSize: '14px',
          outline: 'none',
          boxSizing: 'border-box'
        }}
      />
    </div>

    <button
      type="button"
      onClick={handleUpdatePassword}
      disabled={loading}
      style={{
        width: '100%',
        padding: '12px',
        background: loading ? '#a0aec0' : '#003171',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: loading ? 'not-allowed' : 'pointer',
        boxSizing: 'border-box'
      }}
    >
      {loading ? 'Updating...' : 'Update Password'}
    </button>
  </div>
)}

        {/* Footer */}
        <div style={{ 
          marginTop: '24px', 
          textAlign: 'center', 
          fontSize: '14px',
          color: '#718096'
        }}>
          {mode === 'login' ? (
            <>
              Don't have an account?{' '}
              <button
                onClick={() => switchMode('signup')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#003171',
                  cursor: 'pointer',
                  fontWeight: '600',
                  textDecoration: 'underline',
                  fontSize: '14px'
                }}
              >
                Sign up
              </button>
            </>
          ) : mode === 'signup' ? (
            <>
              Already have an account?{' '}
              <button
                onClick={() => switchMode('login')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#003171',
                  cursor: 'pointer',
                  fontWeight: '600',
                  textDecoration: 'underline',
                  fontSize: '14px'
                }}
              >
                Sign in
              </button>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}